import api from './api';
/**
 * API della modulistica firmata.
 * File separato per non intervenire su api.js: usa la stessa istanza
 * axios, quindi eredita token JWT e gestione errori.
 */
export const modulisticaAPI = {
    // Solo modulo anagrafico
    creaAnagrafica: (data) => api.post('/modulistica/anagrafica', data),
    // Wizard completo: anagrafica + privacy + immagini + FEA
    creaCompleta: (data) => api.post('/modulistica/completa', data),
    // Completamento consensi (paziente "solo prelievi"): cura + immagini
    completaConsensi: (pazienteId, data) => api.post(`/modulistica/completa-consensi/${pazienteId}`, data),
    // Documenti archiviati di un paziente
    getDocumenti: (pazienteId) => api.get(`/modulistica/paziente/${pazienteId}`),
    // Consensi attivi di un paziente
    getConsensi: (pazienteId) => api.get(`/modulistica/consensi/${pazienteId}`),
};
export default modulisticaAPI;
